import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { BehaviorSubject } from 'rxjs';
import { Update } from '../presentation/delegates';

@Injectable()
export class UpdateService implements Update {
    newVersion = new BehaviorSubject(false);

    constructor(swUpdate: SwUpdate) {
        if (swUpdate.isEnabled) {
            swUpdate
                .checkForUpdate()
                .then((update) => {
                    if (update) {
                        this.newVersion.next(true);
                    }
                })
                .catch(() => {
                    // Service worker not supported
                });
        }
    }
}
